export default {
  title: 'Dashboard'
}
